import { canonicalBook, includesVerse, loadCommentary } from './reformationCommentary';

export function commentaryExcerpt(text, limit = 180) {
  const clean = text.replace(/\s+/g, ' ').trim();
  if (!clean) return '';
  const chars = Array.from(clean);
  if (chars.length <= limit) return clean;
  const start = chars.slice(0, limit).join('');
  const sentenceEnd = Math.max(start.lastIndexOf('。'), start.lastIndexOf('！'), start.lastIndexOf('？'), start.lastIndexOf('. '));
  const excerpt = sentenceEnd >= limit / 2 ? start.slice(0, sentenceEnd + 1) : start;
  return `${excerpt.trimEnd()} (...)`;
}

export async function loadSocialCommentary(item, signal) {
  if (item.collection === 'apocrypha') return null;
  const index = await loadCommentary(`index/${canonicalBook(item.book)}/${item.chapter}.json`, signal);
  const entries = (index.entries || []).filter(entry => entry.kind === 'commentary' && entry.verses.includes(item.verse));
  for (const entry of entries) {
    const data = await loadCommentary(entry.chunk, signal);
    const record = data.entries?.[entry.id];
    if (!record) continue;
    const segments = record.segments?.filter(segment => includesVerse(segment.targets, item.book, item.chapter, item.verse)) || [];
    const excerpt = commentaryExcerpt(segments.length ? segments.map(segment => segment.text).join('\n\n') : record.text || '');
    if (excerpt) return { excerpt, author: { calvin: 'カルバン', luther: 'ルター' }[entry.author] || entry.author, language: record.language || data.language || 'en' };
  }
  return null;
}
